import * as THREE from 'three'

export default class Camera {
  public readonly camera: THREE.PerspectiveCamera
  public constructor() {
    // 透視投影(Perspective)と正投影(Orthographic)がある。通常はPerspective。
    // 画角と縦横比で作られる四角錐の描画領域の内、最小〜最大の距離の間が描画される。
    const fov = 60 // 画角
    const aspect = 1
    const near = 1 // 最小距離
    const far = 1000 // 最大距離
    this.camera = new THREE.PerspectiveCamera(fov, aspect, near, far)
    this.camera.up.set(0, 1, 0) // y軸を上にする。
    this.camera.position.set(0, 0, 0) // x, y, zカメラ位置。
    this.camera.lookAt(new THREE.Vector3()) // カメラを中心に向ける。
    this.camera.updateMatrixWorld(true)
  }

  public resize(width: number, height: number): void {
    this.camera.aspect = width / height
  }

  public cameraFitToBox(lookAt: THREE.Vector3, boundingBox: THREE.Box3): void {
    // 位置を初期化
    this.camera.position.set(45, 35, 60)
    this.camera.lookAt(new THREE.Vector3())
    this.camera.updateMatrixWorld(true)

    // console.log(this.camera.position)
    const cameraDir = new THREE.Vector3()
    const nearPoint = new THREE.Vector3()
    const tempBox = new THREE.Box3()

    // 箱位置をコピー
    tempBox.copy(boundingBox)

    // カメラと箱中心位置の距離を計算
    cameraDir.subVectors(this.camera.position, lookAt)
    cameraDir.normalize()
    // console.log(cameraDir)

    // カメラに一番近い角を見つける
    nearPoint.x = cameraDir.x > 0 ? tempBox.max.x : tempBox.min.x
    nearPoint.y = cameraDir.y > 0 ? tempBox.max.y : tempBox.min.y
    nearPoint.z = cameraDir.z > 0 ? tempBox.max.z : tempBox.min.z
    // console.log(nearPoint)

    // 単位ベクトルの軸上で、最もカメラに近い座標を計算する(正直わからない)
    nearPoint.projectOnVector(cameraDir)
    // 最も近い角が「原点を通るスクリーンに平行な面」に来るように移動する
    tempBox.min.sub(nearPoint)
    tempBox.max.sub(nearPoint)

    // クリッピング座標に変換
    const points = [
      new THREE.Vector3(),
      new THREE.Vector3(),
      new THREE.Vector3(),
      new THREE.Vector3(),
      new THREE.Vector3(),
      new THREE.Vector3(),
      new THREE.Vector3(),
      new THREE.Vector3()
    ]
    points[0].set(tempBox.min.x, tempBox.min.y, tempBox.min.z).project(this.camera) // 000
    points[1].set(tempBox.min.x, tempBox.min.y, tempBox.max.z).project(this.camera) // 001
    points[2].set(tempBox.min.x, tempBox.max.y, tempBox.min.z).project(this.camera) // 010
    points[3].set(tempBox.min.x, tempBox.max.y, tempBox.max.z).project(this.camera) // 011
    points[4].set(tempBox.max.x, tempBox.min.y, tempBox.min.z).project(this.camera) // 100
    points[5].set(tempBox.max.x, tempBox.min.y, tempBox.max.z).project(this.camera) // 101
    points[6].set(tempBox.max.x, tempBox.max.y, tempBox.min.z).project(this.camera) // 110
    points[7].set(tempBox.max.x, tempBox.max.y, tempBox.max.z).project(this.camera) // 111

    tempBox.setFromPoints(points)
    // console.log(tempBox)
    // console.log(nearPoint)

    // 最もスクリーンの端に近い点を求める(tempBoxはクリッピング座標系)
    const scale = Math.max(tempBox.max.x, tempBox.max.y, -tempBox.min.x, -tempBox.min.y)
    // console.log(scale)
    // カメラを計算した最適な距離に移動
    this.camera.position.multiplyScalar(scale)
    this.camera.position.add(nearPoint)
    this.camera.lookAt(new THREE.Vector3())
    this.camera.updateMatrixWorld(true)
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Camera.ts